export const loading = <article aria-busy='true' className='on-load'>Loading...</article>